import React from 'react'
import { Box, Heading, Text, VStack, Alert, AlertIcon, useColorModeValue } from '@chakra-ui/react'

import TierBoard from '../../ranking/TierBoard'

export default function Step2(props) {
	const { collection, rankState, setRankState, itemsById } = props
	const poolCount = rankState?.pool?.length ?? 0
	const bodyMuted = useColorModeValue('gray.600', 'bgg.muted')

	return (
		<VStack spacing={5} align="stretch">
			<Box>
				<Heading as="h3" size="md" mb={2}>
					Drag games into tiers
				</Heading>
				<Text color={bodyMuted} fontSize="sm" lineHeight="tall">
					Everything starts in <strong>Unsorted</strong>. Drag box covers into <strong>S</strong> (best) through <strong>F</strong> (lowest). Use{' '}
					<strong>Excluded</strong> to hide a title from the final table. Reorder within a row by dragging.
				</Text>
			</Box>
			{poolCount > 0 ? (
				<Alert status="info" variant="subtle" rounded="lg" fontSize="sm">
					<AlertIcon />
					{poolCount} game{poolCount === 1 ? '' : 's'} still in Unsorted — you can continue anyway.
				</Alert>
			) : null}
			<Box>
				{collection === undefined || collection.length === 0 ? null : (
					<TierBoard rankState={rankState} setRankState={setRankState} itemsById={itemsById} />
				)}
			</Box>
		</VStack>
	)
}
